import { MapMultipleMarkers } from 'common/widgets'
import classNames from './styles.module.scss'


export default function MapView(props) {
  return (
    <div className={classNames.singlePageMap}>
      <MapMultipleMarkers {...props} />
    </div>
  )
}
